import { Select } from "antd";
import "./Input.css";

const CustomSelector = ({
  className = "",
  placeholder = "Select option",
  options = [],
  value,
  onChange,
  ...props
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`custom-selector ${className}`} 
      options={options}
      {...props}
    />
  );
};

export default CustomSelector;
